export default __webpack_public_path__ + "static/media/clear.4ca228bf.svg";